'use client'

/**
 * Path / RT style readout: label + 6px Ant Badge + word.
 * Keep Path and RT as two of these — never merge into one pill.
 */

import React from 'react'
import { Badge } from 'antd'
import type { BadgeProps } from 'antd'
import { DeskReadout } from './DeskReadout'

export interface DeskStatusProps {
  label: string
  text: string
  status: BadgeProps['status']
  'aria-label'?: string
  title?: string
}

export function DeskStatus({
  label,
  text,
  status,
  'aria-label': ariaLabel,
  title,
}: DeskStatusProps) {
  return (
    <DeskReadout
      label={label}
      value={
        <span role="status" aria-live="polite" aria-label={ariaLabel} title={title}>
          <Badge status={status} text={text} />
        </span>
      }
    />
  )
}
